import React from "react";

export const OGImagePage = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center py-10 bg-[#e8eaef]">
      <div
        className="w-[1200px] h-[630px] rounded-[20px] border-[3px] border-[#1e2026] bg-[#f2f2ef] relative overflow-hidden"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(30,32,38,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(30,32,38,0.06) 1px, transparent 1px)",
          backgroundSize: "26px 26px",
        }}
      >
        <div className="grid grid-cols-[1.1fr_0.9fr] h-full">
          <div className="px-10 pt-12">
            <h1 className="text-[82px] leading-[0.95] font-extrabold tracking-[-0.02em] text-[#15161d]">
              Vérifiez si
              <br />
              la hausse
              <br />
              de votre loyer
              <br />
              est acceptable
            </h1>
            <div className="mt-8 w-[540px] rounded-[16px] border-[4px] border-[#1e2026] bg-[#f4f2ef] px-6 py-4">
              <p className="text-[42px] leading-[1.08] font-extrabold text-[#171820]">
                Pour Montréal, selon les nouvelles règles du TAL
              </p>
              <p className="mt-3 text-[30px] leading-[1.15] font-normal text-[#4a4f5b]">
                Par Nicolas Jolicoeur, conseiller d&apos;arrondissement
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center pr-10">
            <svg viewBox="0 0 480 360" className="w-[460px]" aria-label="Graphique de hausse">
              <rect x="40" y="40" width="380" height="260" rx="20" fill="#f4f2ef" stroke="#1e2026" strokeWidth="10" />
              <line x1="92" y1="258" x2="92" y2="198" stroke="#1e2026" strokeWidth="14" strokeLinecap="round" />
              <line x1="178" y1="258" x2="178" y2="172" stroke="#1e2026" strokeWidth="14" strokeLinecap="round" />
              <line x1="264" y1="258" x2="264" y2="142" stroke="#1e2026" strokeWidth="14" strokeLinecap="round" />
              <line x1="350" y1="258" x2="350" y2="98" stroke="#1e2026" strokeWidth="14" strokeLinecap="round" />
              <polyline
                points="92,210 176,160 264,132 350,94"
                fill="none"
                stroke="#d84b4d"
                strokeWidth="12"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="92" cy="210" r="8" fill="#d84b4d" />
              <line x1="350" y1="94" x2="404" y2="58" stroke="#d84b4d" strokeWidth="10" strokeLinecap="round" />
              <polygon points="404,58 386,60 398,74" fill="#d84b4d" stroke="#d84b4d" strokeWidth="10" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OGImagePage;
